import type { ConceptDef } from '../types';

export const tactVehicles: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-vehicles',
  label: 'Expressive Vehicles',
  category: 'Expressive',
  description: 'Show a vehicle; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🚗 car' },
      { prompt: '🚌 bus' },
      { prompt: '🚲 bike' },
      { prompt: '✈ airplane' },
      { prompt: '🚂 train' },
      { prompt: '🚤 boat' },
    ],
  },
};
